<div
	tabindex="1"
	class="product-tour-container"
>
	<!-- Header ------------------------------------------------>
	<div class="modal-header">
		<h4 class="modal-title no-selection">Welcome to Flying Research & Upload</h4>

		<!-- Close button -->
		<button
			class="position-absolute btn btn-default text-white close-button modal-dismiss-control"
			(click)="closeModal()"
		>
			×
		</button>
	</div>

	<!-- Body --------------------------------------------------->
	<div class="modal-body mt-3 pb-0">
		<div class="row m-0 p-0">
			<div class="col-6">
				<div
					class="research-block position-relative"
					role="button"
					(click)="startProductTour(productTourResearch.PRODUCT_TOUR_RESEARCH, EnumWebAppTool.Research)"
				>
					<!-- Research tour -->
					<div [ngClass]="{ 'blur-container': isResearchTourCompleted }">
						<div class="position-absolute icon-container">
							<span class="background-icon">
								<ng-fa-icon
									class="d-inline-flex"
									icon="magnifying-glass"
								></ng-fa-icon>
							</span>
						</div>
						<div class="p-2">
							<div class="title text-center">Research, Keywords & Trademarks</div>
							<div class="img-container">
								<img
									class="img-research no-selection"
									[src]="LOGO_LINKS.RESEARCH_LOGO"
								/>
							</div>
							<div class="text">
								Do all your Research in one tool: Amazon, Redbubble and more. Analyze niches, search for
								trademark registration, and much more.
							</div>
							<div class="take-tour-btn-block">
								<button class="btn btn-default take-tour-btn-style">
									<span class="take-tour-btn-text">New?</span>
									<span class="link-primary">Take a tour</span>
								</button>
							</div>
						</div>
					</div>

					<!-- Tour completed mascot -->
					<div
						class="tour-completed position-absolute"
						*ngIf="isResearchTourCompleted"
					>
						<img
							[src]="MASCOT_IMG_LINKS.LIKE"
							alt="done"
						/>
						<div class="message">
							<p class="m-0">Congratulation 🥳</p>
							<p class="m-0">You have completed this tour</p>
						</div>
					</div>
				</div>
			</div>
			<div class="col-6">
				<div
					class="upload-block position-relative"
					role="button"
					(click)="startProductTour(productTourUpload.PRODUCT_TOUR_UPLOAD, EnumWebAppTool.Upload)"
				>
					<!-- Upload tour -->
					<div [ngClass]="{ 'blur-container': isResearchTourCompleted }">
						<div class="position-absolute icon-container">
							<span class="background-icon">
								<ng-fa-icon
									class="d-inline-flex"
									icon="cloud-arrow-down"
								></ng-fa-icon>
							</span>
						</div>
						<div class="p-2">
							<div class="title text-center">Design Management & Upload Automation</div>
							<div class="img-container">
								<img
									class="img-upload no-selection"
									[src]="LOGO_LINKS.UPLOAD_LOGO"
								/>
							</div>
							<div class="text">
								Organize your designs like a professional in one application and use the most advanced
								upload automation for all platforms.
							</div>
							<div class="take-tour-btn-block">
								<button class="btn btn-default take-tour-btn-style">
									<span class="take-tour-btn-text">New?</span>
									<span class="link-primary">Take a tour</span>
								</button>
							</div>
						</div>
					</div>

					<!-- Tour completed mascot -->
					<div
						class="tour-completed position-absolute"
						*ngIf="isUploadTourCompleted"
					>
						<img
							[src]="MASCOT_IMG_LINKS.LIKE"
							alt="done"
						/>
						<div class="message">
							<p class="m-0">Congratulation 🥳</p>
							<p class="m-0">You have completed this tour</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Visibility state btn -->
		<div class="d-flex justify-content-center my-2">
			<label
				for="tour-state-inputbox"
				class="m-0"
			>
				<input
					type="checkbox"
					name="tourStateInput"
					id="tour-state-inputbox"
					#tourStateInput
				/>
				<span class="no-selection">&nbsp; Don't show again</span>
			</label>
		</div>
	</div>

	<!-- Footer ------------------------------------------------->
	<div class="modal-footer justify-content-center">
		<button
			type="button"
			class="btn btn-primary"
			(click)="dismissCloseModal(tourStateInput)"
		>
			Dismiss & Close
		</button>
	</div>
</div>
